import { redirectTo } from 'Utils/window';
import SelectInput from 'CoreComponents/selectInput/';

const SELECTOR = {
  localeSelect: '#locale_select'
};

class LocaleForm {
  constructor() {
    // Initialise attributes
    this.localeSelect = document.querySelector(SELECTOR['localeSelect']);

    // Bind functions
    this.changeHandler = this.changeHandler.bind(this);

    this._setup();
    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Event handler triggered when the form elements are changed.
   * */
  changeHandler() {
    this._submitForm();
  }

  // Private Methods

  _setup() {
    new SelectInput(this.localeSelect);
  }

  /**
   * Binds event listeners.
   * */
  _addEventListeners() {
    this.localeSelect.addEventListener('change', this.changeHandler);
  }

  /**
   * Serialize form values and redirects to the selected locale translation page.
   * */
  _submitForm() {
    const currentURL = window.location.href;
    let url = new URL(currentURL);

    if (url.pathname.match(/^\/(en|th|ms)/)) {
      url = url.pathname.replace(/^\/(en|th|ms)/, `/${this.localeSelect.value}`);
    } else if (url.pathname) {
      url = `/${this.localeSelect.value}${url.pathname}`;
    } else {
      url = `/${this.localeSelect.value}`;
    }

    redirectTo(url.toString());
  }
}

export default LocaleForm;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/localeForm/index.js